import { useState, useEffect } from 'react';

/**
 * @function useWebBRHistory
 * @desc This hook for handling history and managing disabled state of forward and back buttons.
 * @returns {Object} An object containing the state and handlers for browser history management.
 */
function useWebBRHistory() {
	const [isDisabledForward, setIsDisabledForward] = useState(true);
	const [isDisabledBack, setIsDisabledBack] = useState(true);

	const onForward = () => {
		if (!isDisabledForward) {
			window.history.forward();
		}
	};

	const onBack = () => {
		if (!isDisabledBack) {
			window.history.back();
		}
	};

	useEffect(() => {
		const handleHistoryChange = () => {
			const { length, state } = window.history;

			if (length === 0) {
				setIsDisabledBack(true);
				setIsDisabledForward(true);
			} else if (length > 0) {
				const calc = length - state.idx;
				if (calc > 3) {
					setIsDisabledBack(false);
					setIsDisabledForward(false);
				} else if (calc <= 3) {
					setIsDisabledBack(false);
					setIsDisabledForward(true);
				}
			}
		};

		window.addEventListener('popstate', handleHistoryChange);

		handleHistoryChange();

		return () => {
			window.removeEventListener('popstate', handleHistoryChange);
		};
	}, []);

	const webBRState = { isDisabledForward, isDisabledBack };

	const webBRHandler = { onForward, onBack };

	return { webBRState, webBRHandler };
}

export default useWebBRHistory;
